import { ComponentsCssStringifierSymbol } from '@wix/thunderbolt-catharsis'
import { CompNodeProviderSymbol } from '@wix/thunderbolt-catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { EDITOR_CSS_FEATURES } from './cssFeatures/bundles/editorCssFeatures'
import { RESPONSIVE_MASTER_PAGE_CSS_FEATURES, PUBLIC_CSS_FEATURES } from './cssFeatures/bundles/viewerCssFeatures'
import { CssCompNodesProvider } from './features/cssFeatures'
import { componentsCssStringifierFactory } from './utils/componentsCssStringifier'

export const css: BindFeature = (bind, options) => {
	const loaders = options.isResponsiveMasterPage ? RESPONSIVE_MASTER_PAGE_CSS_FEATURES : PUBLIC_CSS_FEATURES
	Object.values(loaders).forEach((loader) => {
		loader(bind, options)
	})
	bind(CompNodeProviderSymbol).to(CssCompNodesProvider)
	bind(ComponentsCssStringifierSymbol).to(componentsCssStringifierFactory)
}

export const editor: BindFeature = (bind, options) => {
	Object.values(EDITOR_CSS_FEATURES).forEach((loader) => {
		loader(bind, options)
	})

	bind(CompNodeProviderSymbol).to(CssCompNodesProvider)
	bind(ComponentsCssStringifierSymbol).to(componentsCssStringifierFactory)
}
